<script>
  import { onMount } from "svelte"
  import { loadImage } from "../../../../BulkUpload/Script/bulkUpload"
  import LoadingScreen from "../../../../SinglePublish/Components/loadingScreen.svelte"

  export let link = ""
  let showLoading = false
  let imageElem = null

  onMount(async () => {
    try {
      showLoading = true

      await loadImage(link)
    } catch (error) {
      console.error(error)
    } finally {
      showLoading = false
    }
  })
</script>

<div class:hidden={!showLoading}>
  <LoadingScreen msg="Document loading" />
</div>
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class:hidden={showLoading} on:click|self class="fixed inset-0 z-40 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <div class="flex max-h-[80%] max-w-[60%] flex-col items-center space-y-3">
    <img bind:this={imageElem} src={link} alt="DocImage" class=" aspect-auto h-auto max-h-full max-w-full" />
    <p class="text-center text-xl font-bold text-white">To close preview, click within the black area.</p>
  </div>
</div>
